import React, { HTMLAttributes } from "react";
import styled from "styled-components";

const Styled = styled.div`
  box-sizing: border-box;
`;

export interface BoxProps extends HTMLAttributes<HTMLDivElement> {
  ref?: any;
}

/** @deprecated import from `cms`, really should die sometime */
const Box: React.FC<React.PropsWithChildren<BoxProps>> = React.forwardRef(
  (props, ref) => {
    return (
      <Styled {...props} ref={ref as any}>
        {props.children}
      </Styled>
    );
  },
);

export default Box;
